import {
  Disclaimer,
  Div,
  Icon,
  Img,
  VDriveIcon,
  renderFleetImage,
} from '@vgrubs/components';
import { Order } from 'components/src/types/order.types';

export const PoweredByComponent = ({ data }: { data: Order }) => {
  return (
    <>
      <Div
        $desktop
        $borderRight
        $borderLeft
        $p="0 16px"
        $gap="16px"
        $justifyCenter
      >
        <Disclaimer $mb="8">Powered by:</Disclaimer>
        <Div $flex $alignCenter $gap="16px">
          <Icon $size={'70'}>
            <VDriveIcon />
          </Icon>

          <Div $outlineBox $borderColor={'#e3e3e3'} $p="4px 8px" $flex $center>
            <Img
              alt=""
              src={renderFleetImage(data.vDriveProvider || null)}
              $width="80px"
            />
          </Div>
        </Div>
      </Div>

      <Div $mobile $flex $alignCenter $gap="16px" $between>
        <Div $flex $alignCenter>
          <Div $borderRight $mr="16" $p="0 16px 0 0">
            <Icon $sizeSM={50}>
              <VDriveIcon />
            </Icon>
          </Div>

          <Disclaimer $mb="0">Powered by:</Disclaimer>
        </Div>

        <Div $outlineBox $borderColor={'#e3e3e3'} $p="4px 8px" $flex $center>
          <Img
            alt=""
            src={renderFleetImage(data.vDriveProvider || null)}
            $widthSM="60px"
          />
        </Div>
      </Div>
    </>
  );
};
